module.exports = __webpack_public_path__ + "img/reason3.9d23d5a2.png";